import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  pulse?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  pulse = false,
  className = ''
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center text-center font-bold transition-all duration-200 transform active:scale-95 rounded-lg shadow-lg';
  const variants = {
    primary: 'bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white border-b-4 border-green-700',
    secondary: 'bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white border-b-4 border-green-700'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const pulseClass = pulse ? 'animate-pulse' : '';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <a href="#pricing" onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${widthClass} ${pulseClass} ${className} cursor-pointer no-underline px-6 py-4`} data-id="element-184">
      <span className="flex items-center justify-center gap-2 w-full text-center" data-id="element-185">
        {children}
      </span>
    </a>;
}